<template>
  <div :id="id" :style="{ height: height, width: width }"></div>
</template>
<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
import { mapMutations, mapActions } from 'vuex'
// let color = []
export default {
  mixins: [resize],
  props: {
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    return {
      chart: null,
      defaultOptions: {}
    }
  },
  watch: {
    option: {
      handler (newValue, oldValue) {
        this.initChart()
      },
      deep: true
    }
  },
  mounted () {
    let vThat = this
    this.initChart()
    window.addEventListener('resize', function () {
      vThat.SET_CHARTITEM(null)
    })
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      const deviceType = this.$service.state.deviceType
      const isAndroid = this.$store.state.app.isAndroid
      const theme = ['#007EFF', '#1EE4DC', '#FFD71C', '#FF6246', '#83CF46', '#7159FF', '#FFFFFF', '#A352FF', '#3ED5FF', '#F07028']
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      this.chart.clear()
      const OPTIONS = this.option
      if (!OPTIONS.config) { return }
      const seriesData = (OPTIONS.data || []).map((item, index) => {
        return Object.assign({
          type: 'line'
        }, item)
      })
      const option = {
        color: OPTIONS.config.color || theme,
        title: {
          text: this.name,
          x: 'left',
          left: 0,
          top: 0,
          textStyle: {
            fontSize: !isAndroid ? 14 : 10,
            color: 'rgba(255, 255, 255, .6)',
            lineHeight: 11
          },
          ...OPTIONS.config.title
        },
        legend: {
          icon: 'circle',
          itemWidth: !isAndroid ? 10 : 5,
          itemHeight: !isAndroid ? 10 : 5,
          itemGap: 12,
          // top: 0,
          // right: 0,
          textStyle: {
            fontSize: !isAndroid ? 12 : 8,
            color: '#F1F1F3'
          },
          ...OPTIONS.config.legend
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line' // 默认为直线，可选为：'line' | 'shadow'
          },
          triggerOn: 'click'
        },
        grid: {
          left: 0,
          right: 0,
          bottom: 0,
          top: 40,
          containLabel: true,
          ...OPTIONS.config.grid
        },
        xAxis: OPTIONS.config.xAxis && OPTIONS.config.xAxis.length > 0 ? OPTIONS.config.xAxis : [
          {
            type: 'category',
            boundaryGap: false,
            data: OPTIONS.config.xData,
            axisLine: {
              lineStyle: {
                color: 'rgba(255,255,255,.1)'
              }
            },
            axisLabel: {
              textStyle: {
                color: 'rgba(255,255,255,.6)',
                fontSize: !isAndroid ? 12 : 10
              }
            }
          }
        ],
        yAxis: OPTIONS.config.yAxis && OPTIONS.config.yAxis.length > 0 ? OPTIONS.config.yAxis : [
          {
            type: 'value',
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(255,255,255,0.1)'
              }
            },
            axisLabel: {
              textStyle: {
                color: 'rgba(255,255,255,.6)',
                fontSize: !isAndroid ? 12 : 10
              }
            },
            nameTextStyle: {
              color: '#999',
              fontSize: !isAndroid ? 12 : 10
            },
            splitArea: {
              show: false
            },
            splitNumber: OPTIONS.config.splitNumber === undefined ? 5 : OPTIONS.config.splitNumber,
            ...OPTIONS.config.yAxis
          }
        ],
        series: seriesData
      }
      this.chart.setOption(option)
      this.$nextTick(() => {
        setTimeout(() => {
          this.chart.resize()
        }, 50)
      })

      // this.chart.getZr().on('click', () => {
      //   console.log(1)
      // })
      console.log(this)
      this.chart.getZr().on('click', () => {
        this.SET_CHARTITEM(this.chart)
      })
    },
    ...mapMutations(['SET_CHARTITEM'])
  },
  created () {}
}
</script>
